import React from "react";
import { Archive as ArchiveIcon } from "lucide-react";
import {
  DataGrid,
  createTableColumn,
  DataGridHeader,
  DataGridRow,
  DataGridHeaderCell,
  DataGridBody,
  DataGridCell,
  Text,
  TableColumnDefinition,
  Card,
  Title3,
  Spinner,
} from "@fluentui/react-components";
import {
  ResultCardItem,
  ResultTypes,
  ResultsCardProps,
} from "./ResultsCard.types";
import moment from "moment";
import { useCardStyles } from "../index.styles";
import { match } from "ts-pattern";
import { ApiResponseType } from "Utils";
import { useMapResultCardItem } from "./useMapResultCardItemV2";
import { SearchResult, SearchResultItem } from "types/service/searchResult";
import { useSearch } from "hooks/useSearch";
import { RawFileRender } from "./renders/RawFileRender";

const columns: TableColumnDefinition<SearchResult>[] = [
  createTableColumn<SearchResult>({
    columnId: "doc",
    compare: (a, b) => {
      return a.cnpj.localeCompare(b.cnpj);
    },
    renderHeaderCell: () => {
      return "CNPJ";
    },
    renderCell: (item) => {
      return item.cnpj;
    },
  }),
  createTableColumn<SearchResult>({
    columnId: "queryDate",
    compare: (a, b) => {
      return a.createdOn < b.createdOn ? 0 : 1;
    },
    renderHeaderCell: () => {
      return "Data da pesquisa";
    },
    renderCell: (item) => {
      return moment(item.createdOn).format("DD/MM/YYYY");
    },
  }),
  createTableColumn<SearchResult>({
    columnId: "file",
    // compare: (a, b) => {
    //   return a.file.label.localeCompare(b.file.label);
    // },
    renderHeaderCell: () => {
      return "Arquivo";
    },
    renderCell: (item: SearchResult) => {
      //   match(item)
      //     // .with({ apiType: ApiResponseType.Comprot }, () => {
      //     //   return <RawFileRender item={item} key={item.id} />;
      //     // })
      //     // .with({ apiType: ApiResponseType.PerDecomp }, () => {
      //     //   return <CreateFileRender item={item} key={item.id} />;
      //     // })
      //     .with({ dataset: ApiResponseType.ProcessosJudiciais }, () => {
      //       // return <CreateFileRender item={item} key={item.id} />;
      //     })
      //     // .with({ apiType: ApiResponseType.DebitosFederais }, () => {
      //     //   return <CreateFileRender item={item} key={item.id} />;
      //     // })
      //     // .with({ apiType: ApiResponseType.ProjetosPublicos }, () => {
      //     //   return <CreateFileRender item={item} key={item.id} />;
      //     // })
      //     // .with({ apiType: ApiResponseType.LeiDoBem }, () => {
      //     //   return item.doc;
      //     // })
      //     .otherwise(null)
      // );
      return null;
    },
  }),
  createTableColumn<SearchResult>({
    columnId: "dataset",
    compare: (a, b) => {
      return a.dataset.localeCompare(b.dataset);
    },
    renderHeaderCell: () => {
      return "API";
    },
    renderCell: (item) => ResultTypes[item.dataset].label,
  }),
];

const getRowId = (item: SearchResult) => {
  return item.id;
};

export default function ResultsCard({}: ResultsCardProps) {
  const cardStyles = useCardStyles();
  const { data: results, isFetched, isFetching, isError } = useSearch();

  if (isFetching) return <Spinner />;
  if (!results) return null;
  console.log(results);

  return (
    <Card style={{ width: "100%" }} className={cardStyles.card}>
      <div>
        <ArchiveIcon style={{ marginRight: "11px", paddingTop: "2px" }} />
        <Title3 className={cardStyles.title3}>Pesquisas realizadas</Title3>
      </div>
      <DataGrid
        arial-label="Default table"
        items={results}
        columns={columns}
        sortable
        getRowId={getRowId}
      >
        <DataGridHeader>
          <DataGridRow>
            {({ renderHeaderCell }) => (
              <DataGridHeaderCell>
                <Text weight="bold">{renderHeaderCell()}</Text>
              </DataGridHeaderCell>
            )}
          </DataGridRow>
        </DataGridHeader>
        <DataGridBody<ResultCardItem>>
          {({ item, rowId }) => (
            <DataGridRow<ResultCardItem> key={rowId}>
              {({ renderCell }) => (
                <DataGridCell>{renderCell(item)}</DataGridCell>
              )}
            </DataGridRow>
          )}
        </DataGridBody>
      </DataGrid>
    </Card>
  );
}
